module.exports = __webpack_public_path__ + "static/img/press_youtube.524ff2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press_youtube.png
// module id = rfQl
// module chunks = 0